function Details() {
  return (
    <main className="page-panel page-event px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-2xl font-semibold mb-4">Schedule</h1>

        <section className="info-window rounded-lg p-6 mb-6">
          <div className="font-bold mb-3" style={{ color: 'var(--accent-dark)', fontSize: '1.25rem' }}>
            Weekend Schedule
          </div>

          <h2 className="text-lg font-medium mb-3">Friday, September 18</h2>
          <div className="readable-font space-y-2 mb-3">
            <div>7:00 - 10:00 PM: Start the weekend at Hotel Lilien with a drink and say hello! Come and go as you please in casual dress.</div>
          </div>

          <h2 className="text-lg font-medium mb-3">Saturday, September 19</h2>
          <div className="readable-font space-y-2 mb-3">
            <div>4:00 PM: Welcome Cocktails</div>
            <div>5:00 PM: Ceremony</div>
            <div>Dinner and Dancing to follow</div>
          </div>
          <p className="readable-font mb-5">Cocktail Attire - Our celebration will be held mainly outdoors; keep that in mind when considering your dress.</p>

          <h2 className="text-lg font-medium mb-3">Sunday, September 20</h2>
          <div className="readable-font space-y-2">
            <p>8:00 - 11:00 AM: Coffee cart at Hotel Lilien. Come get a drink and say goodbye to us on your way out of town!</p>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Details;
